import { render } from "./designDept.vue?vue&type=template&id=dd9cfab2"
import script from "./designDept.vue?vue&type=script&lang=js"
export * from "./designDept.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__